import { useState, useEffect } from 'react';
import { db } from '../firebase/firebase';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';

export function useCollection<T extends { id?: string }>(
  collectionPath: string,
  orderByField: string = 'createdAt',
  orderDirection: 'asc' | 'desc' = 'desc'
): T[] {
  const [items, setItems] = useState<T[]>([]);

  useEffect(() => {
    const q = query(
      collection(db, collectionPath),
      orderBy(orderByField, orderDirection)
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        })) as T[];
        setItems(data);
      },
      (error) => {
        console.error(`Error listening to collection ${collectionPath}:`, error);
        setItems([]);
      }
    );
    return () => unsubscribe();
  }, [collectionPath, orderByField, orderDirection]);

  return items;
}

export default useCollection;
